import { render, staticRenderFns } from "./OrgAppeals.vue?vue&type=template&id=787bfa10&scoped=true"
import script from "./OrgAppeals.vue?vue&type=script&lang=js"
export * from "./OrgAppeals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "787bfa10",
  null
  
)

export default component.exports